import { motion } from "framer-motion";

const AnimatedSection = ({ children, className = "", delay = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ 
        opacity: 1, 
        y: 0,
        transition: {
          duration: 0.8,
          delay: delay,
          ease: [0.21, 0.47, 0.32, 0.98]
        }
      }}
      viewport={{ 
        once: true,
        margin: "-50px",
        amount: 0.3
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedSection; 